import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { get, last} from 'lodash'

import { sendOrderEmail } from '../../actions/order'
import { printOrder, fetchPrinters } from '../../actions/printer'

import { getDeviceSubtype, getIsSuitesOrTabsMode, getReceiptPrinterUuid } from '../../selectors/config'
import { makeGetCustomerOrderingPreferences, makeGetCustomerPayments, getActiveCustomerId } from '../../selectors/customer'
import { makeGetCurrentMenu } from '../../selectors/menus'
import { makeGetOrder, makeGetServiceChargeLegalText } from '../../selectors/order'
import { getActiveRevenueCenterId } from '../../selectors/revenueCenter'
import { getPrinters } from '../../selectors/printer'

import makeCustomerPreferences from '../../utils/customerPreferences'

import ReceiptMenu from '../../components/receipt/ReceiptMenu'

const getPaymentId = (order) => {
  const paymentInfo = order?.paymentInfo ?? []
  const validPayments = paymentInfo?.filter?.(payment => payment.amountInCents > 0)
  return last(validPayments)?.uuid
}

const mapStateToProps = (state, ownProps) => {
  const orderUuid = get(ownProps, 'match.params.orderUuid', undefined)
  const getOrder = makeGetOrder()
  let order = {}

  order = orderUuid ? getOrder(state, orderUuid) : getOrder(state, state.order.currentOrderId)

  let paymentId = ownProps?.match?.params?.paymentId
  if (!paymentId || paymentId === 'cash-receipt') {
    paymentId = getPaymentId(order)
  }

  const getMenu = makeGetCurrentMenu()
  const menu = getMenu(state)
  const customerId = get(order, 'customerId', getActiveCustomerId(state))
  const revenueCenterId = get(order, 'standUuid', getActiveRevenueCenterId(state))

  const getCustomerOrderingPreferences = makeGetCustomerOrderingPreferences()
  const preferences = getCustomerOrderingPreferences(state, customerId, revenueCenterId)

  const getCustomerPayments = makeGetCustomerPayments()
  const payments = getCustomerPayments(state, customerId)

  const customerSettings = makeCustomerPreferences(preferences, payments)
  const customerEmail = get(customerSettings, 'receiptEmail', '')

  const deviceSubtype = getDeviceSubtype(state)
  const showEmail = getIsSuitesOrTabsMode(state)

  const getServiceChargeLegalText = makeGetServiceChargeLegalText()
  const serviceChargeLegal = getServiceChargeLegalText(state, orderUuid)

  const printers = getPrinters(state)
  const deviceReceiptPrinterUuid = getReceiptPrinterUuid(state)

  return {
    customerEmail,
    deviceReceiptPrinterUuid,
    deviceSubtype,
    menu,
    order,
    printers,
    paymentId,
    serviceChargeLegal,
    showEmail,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const replace = ownProps?.history?.replace

  return {
    onMount: () => {
      dispatch(fetchPrinters())
    },
    sendEmails: (orderUuid, emails, paymentId) => dispatch(sendOrderEmail({ orderUuid, emails, paymentUuid: paymentId })),
    printOrder: (params) => dispatch(printOrder(params)),
    onDone: (orderId) => {
      const path = orderId === undefined ? '/tabs' : `/tabs/${orderId}`
      // eslint-disable-next-line no-unused-expressions
      replace?.(path)
    },
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReceiptMenu))
